import React from 'react';
import './styles/ModernSwitch.css';

const ModernSwitch = ({ 
  label, 
  checked = false, 
  onChange, 
  disabled = false,
  size = "md", // sm, md, lg
  color = "blue", // blue, green, purple, orange
  description = "",
  className = ""
}) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div className={`modern-switch-container ${className}`}>
        <div 
          className={`modern-switch ${disabled ? 'disabled' : ''}`}
          onClick={handleToggle}
        >
          <div 
            className={`modern-switch-track size-${size} ${
              checked ? `checked-${color}` : ''
            }`}
          >
            <div 
              className={`modern-switch-toggle size-${size} ${
                checked ? 'checked' : ''
              }`}
            />
          </div>
        </div>
        
        {(label || description) && (
          <div className="modern-switch-wrapper">
            {label && (
              <label 
                className={`modern-switch-label ${disabled ? 'disabled' : ''}`}
                onClick={handleToggle}
              >
                {label}
              </label>
            )}
            {description && (
              <div className="modern-switch-description">
                {description}
              </div>
            )}
          </div>
        )}
      </div>
  );
};

export default ModernSwitch;
